
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/conversation-sources/facebook/facebookSubscribedPage.tmpl");
    var Button = require("ui/button/Button");

    var FacebookSubscribedPageView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        FacebookSubscribedPageView = Marionette.ItemView.extend({
            tagName: "ul",
            className: "facebook-subscribed-page",
            template: template,
            ui:{
                name: ".facebook-subscribed-page-name"
            },
            onRender: function() {
                this.ui.name.text(this.model.get("name"));
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return FacebookSubscribedPageView;

});
